import axios from 'axios'

const APIService = {

  constructor () {
  },
  
  setEndpoints(endpoint, endpointRefresh){
    this.endpoint = endpoint+'/api/v3';
    this.endpointRefresh = endpointRefresh;
  },

  getTags (callback) {
    axios.get(this.endpoint + '/tags').then((response) => {
      if (response.data && response.data.results) {
        callback(response.data.results)
      }
    })
  },

  getForms (idForm, callback) {
    axios.get(this.endpoint + '/forms/'+idForm).then((response) => {
      if (response.data) {
        callback(response.data)
      }
    })
  },

  getSteps (idForm, callback) {
    axios.get(this.endpointRefresh + '/forms/'+idForm+'/steps').then((response) => {
      if (response.data && response.data.steps) {
        callback(response.data.steps)
      }
    })
  },

  getPublicPost (consultUrl, key, callback) {
    axios.get(this.endpointRefresh + ((consultUrl + '/key/'+key).replaceAll('//','/')) ).then((response) => {
      if (response.data && response.data.post) {
        callback(response.data.post)
      }
    })
  },

  savePost (data, callbackThen, callbackError) {

    var rqHeaders = {};

    if(data.token && data.token.length > 0){
      rqHeaders = {
          Authorization: `Bearer ${data.token}`
      }
    }

    axios.post(this.endpoint + '/posts', data.data, {
      headers: rqHeaders
    }).then((response) => {
      callbackThen(response)
    }).catch((error) => {
      callbackError(error)
    })
  },

  verifyRecaptcha (data, callbackThen, callbackError) {
    axios.post(this.endpointRefresh + '/captcha', data).then((response) => {
      callbackThen(response)
    }).catch((error) => {
      callbackError(error)
    })
  },

  uploadMedia (data, callbackThen, callbackError) {
    axios.post(this.endpoint + '/media', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then((response) => {
      callbackThen(response)
    }).catch((error) => {
      callbackError(error)
    })
  }
}

export { APIService }
